import { TemplateRegistry } from "./types";
import { gridTemplate } from "./gridTemplate";
import { listTemplate } from "./listTemplate";

export * from "./types";
export * from "./utils";

/**
 * Global template registry
 * All available templates for the Talentech Feed plugin
 */
export const templateRegistry: TemplateRegistry = {
  grid: gridTemplate,
  list: listTemplate,
};

/**
 * Get a template by ID, fallback to grid if not found
 */
export function getTemplate(templateId: string) {
  return templateRegistry[templateId] || templateRegistry.grid;
}

/**
 * Get all template options for trait selector
 */
export function getTemplateOptions() {
  return Object.values(templateRegistry).map((template) => ({
    id: template.id,
    name: template.name,
  }));
}

/**
 * Default template ID
 */
export const DEFAULT_TEMPLATE_ID = "grid";

